import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@slate/ui';
import type { PlatformBridge } from '@slate/core';
import '@slate/ui/styles.css';
import { bootUpdater } from './updaterController';

function isTauri(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

async function resolvePlatform(): Promise<PlatformBridge> {
  if (isTauri()) {
    const { TauriPlatform } = await import('./platform/TauriPlatform');
    return new TauriPlatform();
  }
  const { WebPlatform } = await import('./platform/WebPlatform');
  return new WebPlatform();
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');
const root = createRoot(rootEl);

void resolvePlatform().then((platform) => {
  root.render(
    <StrictMode>
      <App platform={platform} />
    </StrictMode>,
  );
  bootUpdater();
});
